type SportId = number;

const sportIds = {
    volleyball: 1,
    tennis: 2,
    hockey: 3,
    basketball: 4,
    football: 5,
    snooker: 6,
    rugby: 8, // not licenced
    handball: 11,
    nfl: 12,
    darts: 13,
    badminton: 14,
    futsal: 17,
    baseball: 20,
    tableTennis: 24,
    beachVolleyball: 28,
    cricket: 32,
    eBasketball: 70,
    eSoccer: 75,
    eIceHockey: 157,
} as const;

const licencedSportList: SportId[] = [
    sportIds.volleyball,
    sportIds.tennis,
    sportIds.hockey,
    sportIds.basketball,
    sportIds.football,
    sportIds.snooker,
    sportIds.handball,
    sportIds.nfl,
    sportIds.darts,
    sportIds.badminton,
    sportIds.futsal,
    sportIds.baseball,
    sportIds.tableTennis,
    sportIds.beachVolleyball,
    sportIds.cricket,
    sportIds.eBasketball,
    sportIds.eSoccer,
    sportIds.eIceHockey,
];

export function createIsSportLicencedForVisualisation(licencedSportList: SportId[]): (sportId: SportId) => boolean {
    const licencedSportsSet = new Set(licencedSportList);
    return function isSportLicencedForVisualisation(sportId: SportId): boolean {
        return licencedSportsSet.has(sportId);
    };
}

export const isSportLicencedForVisualisation = createIsSportLicencedForVisualisation(licencedSportList);
